import type { Signal } from '@builder.io/qwik';
import { getPathFromUrl } from '~/utilities/getPathFromUrl';

/**
 * Updates the URL based on scroll position for a finite scroll feature.
 *
 * This function iterates through a list of scroll start points and updates the URL
 * when the scroll position exceeds a specific distance from the top. It ensures
 * that the URL is only updated if the new path differs from the current path.
 *
 * @param {Signal} finiteScrollStarts - A signal containing the scroll start points
 *        with distances from the top and respective URLs.
 * @param {number} scrollTop - The current vertical scroll position.
 * @param {Signal} currentPath - A signal holding the current path.
 * @param {string | undefined} env - The current environment (e.g., 'development').
 */
export const updateFiniteScrollUrl = (
  finiteScrollStarts: Signal,
  scrollTop: number,
  currentPath: Signal,
  env: string | undefined
) => {
  let maybeUrl = '';

  finiteScrollStarts.value.forEach(
    (each: { distanceFromTop: number; url: string }) => {
      if (scrollTop > each.distanceFromTop) {
        maybeUrl = each.url;
      }
    }
  );

  const path = getPathFromUrl(maybeUrl);

  if (path === currentPath.value || !path) return;

  currentPath.value = path;

  if (env === 'development') {
    console.log('Update path: ' + path);
  } else {
    history.replaceState(null, '', path);
  }
};
